export const FilterRuleItem = ({ filterRow, getLogicalOperatorText }) => {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            padding: "1rem 1.25rem",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
            flexWrap: "wrap"
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                minWidth: "fit-content"
            }}>
                <span style={{
                    fontWeight: "600",
                    color: "#495057",
                    fontSize: "14px"
                }}>
                    {filterRow?.column}
                </span>
            </div>
            
            <div style={{
                padding: "0.25rem 0.75rem",
                backgroundColor: "#007bff",
                color: "white",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: "500"
            }}>
                {filterRow?.operatorName}
            </div>
            
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                flex: 1,
                minWidth: "120px"
            }}>
                {filterRow?.filterValue2 !== null && (
                    <>
                        <span style={{
                            padding: "0.25rem 0.75rem",
                            backgroundColor: "#e9ecef",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500"
                        }}>
                            {filterRow?.filterValue2}
                        </span>
                        <span style={{ color: "#6c757d" }}>to</span>
                    </>
                )}
                <span style={{
                    padding: "0.25rem 0.75rem",
                    backgroundColor: "#e9ecef",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "500"
                }}>
                    {filterRow?.filterValue}
                </span>
            </div>
            
            {filterRow?.logicalOperator && (
                <div style={{
                    padding: "0.25rem 0.75rem",
                    backgroundColor: "#17a2b8",
                    color: "white",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "500"
                }}>
                    {getLogicalOperatorText(filterRow?.logicalOperator)}
                </div>
            )}
        </div>
    );
};
